import {
  CreatePositionOrderRequest,
  PositionAssetTypeEnum,
} from "@/src/features/api/memberApi";

// 直接使用接口中的 side 定义
export enum TransactionType {
  Buy = "Buy",
  Sell = "Sell",
}

export interface Transaction {
  // orderId
  id: string;
  orderId: string;
  assetType?: PositionAssetTypeEnum;
  type: TransactionType;
  coin: string;
  coinIcon: string;
  quantity: number;
  pricePerCoin: number;
  dateTime: string;
  fees: number;
  cost: string;
  platform_order_id: string;
}

export interface TransactionFormData {
  type: TransactionType;
  quantity: string;
  pricePerCoin: string;
  dateTime: string;
  fees: string;
  asset?: {
    assetId: string;
    assetType: PositionAssetTypeEnum | null;
    currency: string;
  };
}

export interface TransactionModalProps {
  mode: "add" | "edit";
  disabledSelect?: boolean;
  initialData: {
    quantity?: number;
    type?: TransactionType;
    assetId?: string;
    assetType?: PositionAssetTypeEnum;
    accountId: string;
    pricePerCoin?: number;
    dateTime?: string;
    fees?: number;
    cost?: number;
    orderId?: string;
    platform_order_id?: string;
    currency?: string;
  };
}

export interface DeleteTransactionModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

// 驼峰转下划线工具函数
const camelToSnakeCase = (str: string): string => {
  return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
};

// 将表单数据转换为API请求格式
export const transformFormDataToOrderRequest = (
  formData: TransactionFormData,
  assetId: string,
  assetType: PositionAssetTypeEnum,
): CreatePositionOrderRequest => {
  const timestamp = new Date(formData.dateTime).getTime();

  const camelCaseRequest = {
    side: formData.type === TransactionType.Buy ? "BUY" : "SELL",
    assetId: assetId,
    assetType: assetType,
    amount: Number(formData.quantity),
    fee: Number(formData.fees),
    price: Number(formData.pricePerCoin),
    orderTime: timestamp,
    openTime: timestamp,
  };

  // 转换为下划线格式
  const snakeCaseRequest: CreatePositionOrderRequest = {} as any;
  Object.keys(camelCaseRequest).forEach((key) => {
    const snakeKey = camelToSnakeCase(key);
    (snakeCaseRequest as any)[snakeKey] = (camelCaseRequest as any)[key];
  });

  return snakeCaseRequest;
};
